<template>
  <div>
    <div v-if="isClient" class="clientHead">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <header
              class="d-flex justify-content-between align-items-center flex-wrap py-2"
            >
              <!-- Left side -->
              <div class="d-flex align-items-center flex-wrap">
                <router-link
                  to="/dashboardoption"
                  class="navbar-brand"
                  v-if="isAdmin"
                >
                <div class="d-flex align-items-center">
                <img
                    src="../../assets/img/brand/BondLogix_Horiz.png" width="270px"
                    class="logo ml-3"
                  />
                  <!-- <img
                    width="140"
                   
                    src="../../assets/img/bondlogo-white.png"
                    class="logo"
                  /> -->
                  </div>
                </router-link>

          
                <a
                  href="https://www.drlgroup.net/"
                  target="_blank"
                  v-if="!isAdmin"
                >
                 <div class="d-flex align-items-center">
                     <img
                    src="../../assets/img/brand/BondLogix_Horiz.png" width="270px"
                    class="logo ml-3"
                  />
                  </div>
                </a>
                <!-- <div class="search-box d-flex align-items-center ml-3" v-if="isOnlyClientDashboard">
                  <i class="fa fa-search cursor-pointer" @click="search"></i>
                  <input
                    type="text"
                    @keyup.enter="search"
                    class="form-control"
                    placeholder="Search here"
                    v-model="searchText"
                  />
                  <div
                    v-if="searchText && searchText.trim() != ''"
                    style="margin-left: -20px"
                    class="clear-icon cursor-pointer"
                    @click="
                      searchText = ''
                      search()
                    "
                  >
                    <i class="fa fa-times"></i>
                  </div>
                </div> -->
              </div>

              <!-- Right side -->
              <div class="settings d-flex align-items-center mt-2 mt-md-0">
                <button v-if="isClientUser" type="button" class="btn btn-outline-primary start-tour" @click="startTour">Start Tour</button>
              <span class="mr-3" style="font-size: 14px; color: rgb(162 162 162);">
                  <i class="fa fa-phone  fa-flip-horizontal mr-1"></i>
                  <a href="tel:+18666644040" style="color: rgb(162 162 162);">(866) 664-4040</a>
                </span>
                <span class="mr-3" style="font-size: 14px; color: rgb(162 162 162);">
                  <i class="fa fa-envelope mr-1"></i>
                  <a href="mailto:drl@drlgroup.net" style="color: rgb(162 162 162);">drl@drlgroup.net</a>
                </span>

                <!-- <span><a><i class="fa fa-bell"></i></a></span>
            <span class="ml-3"><a><i class="fa fa-cog"></i></a></span> -->
                <!-- <span class="avatar ml-3"  @click="logout" >{{user.firstName ? user.firstName.charAt(0) : ""}}</span> -->
                <a
                  class="nav-link pr-0"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle">
                      {{ user.firstName ? user.firstName.charAt(0) : '' }}
                      <!-- <img alt="Image placeholder" src="../../assets/img/profile.jpg" /> -->
                    </span>
                    <div class="media-body ml-2 d-none d-lg-block">
                      <!-- <span class="mb-0 text-sm font-weight-bold">
                    {{user.firstName ? user.firstName.charAt(0) : ""}}. {{user.lastName}}</span><br> -->
                      <!-- <span class="mb-0 text-sm font-weight-bold">{{roleArray.join(' | ')}}</span> -->
                    </div>
                  </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="dropdown-header noti-title">
                    <h4 class="text-overflow m-0">
                      Hi, {{ user.firstName ? user.firstName.charAt(0) : '' }}.
                      {{ user.lastName }}!
                    </h4>
                    <h6 class="text-overflow m-0">
                      {{ roleArray.join(' | ') }}
                    </h6>
                  </div>
                  <div class="dropdown-divider"></div>
                  <a
                    href="javascript:void(0);"
                    @click="showMFAPopup = true"
                    class="dropdown-item"
                  >
                    <i class="fa fa-handshake" aria-hidden="true"></i>
                    <span>Turn on MFA</span>
                  </a>
                  <router-link 
                    to="/client/changepassword"
                    class="dropdown-item"
                  >
                    <i class="fa fa-key" aria-hidden="true"></i>
                    <span>Change Password</span>
                  </router-link>
                   <router-link v-if="isClientUser"
                    to="/client/updateclient"
                    class="dropdown-item"
                  >
                    <i class="fa fa-user" aria-hidden="true"></i>
                    <span>Edit Profile</span>
                  </router-link>

                  <div class="dropdown-divider"></div>
                  <a
                    href="javascript:void(0);"
                    @click="logout"
                    class="dropdown-item"
                  >
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                    <span>Logout</span>
                  </a>
                </div>
              </div>
            </header>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <nav class="navbar navbar-top navbar-expand navbar-dark bg-primary">
        <div class="container-fluid">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <div v-if="modules.length > 1" style="display: inline-flex">
              <router-link v-if="isTradeRecap" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"><i class="fas fa-gavel"></i></span
                  >Trade Recap
                </div>
              </router-link>
              <div v-if="isBidSide">
                <router-link to="/dashboardoption">
                  <div class="brand">
                    <img src="../../assets/img/brand/trade.png" /> Bid Side
                  </div>
                </router-link>
                <!-- <router-link to="/dashboardoption" v-if="isTrader && !isAdmin && !isEditor && !isSuperAdmin">
              <div class="brand"><img src="../../assets/img/brand/trade.png"/> Bid Side</div>
            </router-link> -->
              </div>
              <router-link v-if="isIms" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"
                    ><i class="fas fa-hand-holding-usd"></i></span
                  >IMS
                </div>
              </router-link>
              <router-link v-if="isOfferingFeed" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"><i class="fas fa-rss"></i></span
                  >OFFERING FEED
                </div>
              </router-link>

              <router-link v-if="isReport" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"
                    ><i class="fas fa-dollar-sign"></i></span
                  >REPORTS
                </div>
              </router-link>
              <router-link v-if="isBidAccumulator" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"><i class="fas fa-database"></i></span
                  >BID ACCUMULATOR
                </div>
              </router-link>
              <router-link v-if="isTicketSystem" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"
                    ><i class="fas fa-folder-open"></i></span
                  >TICKETING CATALOGUE
                </div>
              </router-link>
              <router-link v-if="isAutoBidder" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"><i class="fas fa-bolt"></i></span>AUTO
                  BIDDER
                </div>
              </router-link>
              <router-link v-if="isDeMinimis" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"><i class="fas fa-calculator"></i></span
                  >DE MINIMIS
                </div>
              </router-link>
               <router-link v-if="isBrockerDealer" to="/dashboardoption">
                <div class="brand">
                  <span class="bid-brand"><i class="fas fa-bolt"></i></span
                  >COMPLIANCE
                </div>
              </router-link>
            </div>

            <!-- Navbar links -->
            <ul class="navbar-nav align-items-center ml-md-auto">
              <li class="nav-item d-xl-none">
                <!-- Sidenav toggler -->
                <div
                  class="pr-3 sidenav-toggler sidenav-toggler-dark"
                  data-action="sidenav-pin"
                  data-target="#sidenav-main"
                >
                  <div class="sidenav-toggler-inner">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="navbar-nav align-items-center ml-auto ml-md-0">
              <!-- <li v-if="isWebsocketConnected && isBidSide" class="nav-item dropdown">
              <button class="btn btn-success" @click="testBid()">Test Alert Bid</button>
          </li>
          <li v-if="isIms" class="nav-item dropdown">
              <button class="btn btn-success" @click="testIms()">Test Alert Ims</button>
          </li> -->
              <li
                class="nav-item dropdown"
                v-if="
                  (isTrader || isEditor) && !isTradeRecap && !isBrockerDealer
                "
              >
                <toggle-button
                  :sync="true"
                  v-model="setAsAway"
                  @change="setAway()"
                />
                <label class="text-white mb-0 text-sm font-weight-bold"
                  >SET AS AWAY
                </label>
              </li>
              <li class="nav-item dropdown" style="top: 8px">
                <TraderNotification />
              </li>
              <li v-if="$route.name == 'dashboard'">
                <Tradecount v-bind:fromdate="fromdate" v-bind:todate="todate" />
              </li>
              <li v-if="$route.name == 'dashboard'">
                <button
                  type="button"
                  class="btn btn-print"
                  @click="showPrintOptions()"
                >
                  <i class="fas fa-print"></i>
                </button>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link pr-0"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div class="media align-items-center">
                    <span
                      class="avatar avatar-sm rounded-circle"
                      style="background-color: #8328cd"
                    >
                      {{ user.firstName ? user.firstName.charAt(0) : '' }}
                      <!-- <img alt="Image placeholder" src="../../assets/img/profile.jpg" /> -->
                    </span>
                    <div class="media-body ml-2 d-none d-lg-block">
                      <!-- <span class="mb-0 text-sm font-weight-bold">
                    {{user.firstName ? user.firstName.charAt(0) : ""}}. {{user.lastName}}</span><br> -->
                      <!-- <span class="mb-0 text-sm font-weight-bold">{{roleArray.join(' | ')}}</span> -->
                    </div>
                  </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="dropdown-header noti-title">
                    <h4 class="text-overflow m-0">
                      Hi, {{ user.firstName ? user.firstName.charAt(0) : '' }}.
                      {{ user.lastName }}!
                    </h4>
                    <h6 class="text-overflow m-0">
                      {{ roleArray.join(' | ') }}
                    </h6>
                  </div>
                  <div class="dropdown-divider"></div>

                  <router-link
                    v-if="isBidSide"
                    to="/bidside/changepassword"
                    class="dropdown-item"
                  >
                    <i class="fa fa-key" aria-hidden="true"></i>
                    <span>Change Password</span>
                  </router-link>
                  <router-link
                    v-if="!isBidSide"
                    to="/changepassword"
                    class="dropdown-item"
                  >
                    <i class="fa fa-key" aria-hidden="true"></i>
                    <span>Change Password</span>
                  </router-link>
                  <a
                    href="javascript:void(0);"
                    @click="showMFAPopup = true"
                    class="dropdown-item"
                  >
                    <i class="fa fa-handshake" aria-hidden="true"></i>
                    <span>Turn on MFA</span>
                  </a>
                  <a
                    href="javascript:void(0);"
                    v-if="isWebsocketConnected && isBidSide"
                    @click="testBid()"
                    class="dropdown-item"
                  >
                    <i class="fa fa-bell" aria-hidden="true"></i>
                    <span>Test Alert BID</span>
                  </a>
                  <a
                    href="javascript:void(0);"
                    v-if="isIms"
                    @click="testIms()"
                    class="dropdown-item"
                  >
                    <i class="fa fa-bell" aria-hidden="true"></i>
                    <span>Test Alert IMS</span>
                  </a>
                  <div class="dropdown-divider"></div>
                  <a
                    href="javascript:void(0);"
                    @click="logout"
                    class="dropdown-item"
                  >
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                    <span>Logout</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <FcmNotification />
      </nav>
    </div>
    <MFA v-if="showMFAPopup" @close="showMFAPopup = false" />
  </div>
  <!-- Topnav -->
</template>
<script>
import Tradecount from '../traderecap/Tradecount'
import authService from '@/authService'
import TraderNotification from '../bidside/trader/TraderNotification'
import FcmNotification from '../common/FcmNotification'
import MFA from '../common/SetupMfaModal'

// import cognitoService from '@/cognito/cognitoidentityserviceprovider.js';
import config from '@/config'
// import axios from "axios";

export default {
  name: 'Header',
  components: {
    Tradecount,
    TraderNotification,
    FcmNotification,
    MFA
  },
  watch: {
    $route () {
      this.isBidSide = window.location.pathname.includes('bidside')
      this.isTradeRecap = window.location.pathname.includes('traderecap')
      this.isIms = window.location.pathname.includes('ims')
      this.isBidAccumulator =
        window.location.pathname.includes('bidaccumulator')
      this.isReport = window.location.pathname.includes('reports')
      this.isTicketSystem = window.location.pathname.includes('ticketsystem')
      this.isAutoBidder = window.location.pathname.includes('autobidder')
      this.isClient = window.location.pathname.includes('client'),
      this.isDeMinimis = window.location.pathname.includes('de-minimis')

    }
  },
  // props: ["fromdate", "todate"],
  data () {
    return {
      user: {
        firstName: ''
      },
      modules: [],
      roleArray: [],
      accessToken: null,
      cognitoSub: null,
      isTrader: false,
      isEditor: false,
      isSuperAdmin: false,
      isAdmin: false,
      fromdate: null,
      todate: null,
      isBidSide: window.location.pathname.includes('bidside'),
      isTradeRecap: window.location.pathname.includes('traderecap'),
      isIms: window.location.pathname.includes('ims'),
      isReport: window.location.pathname.includes('reports'),
      isAutoBidder: window.location.pathname.includes('autobidder'),
      isDev:
        window.location.host ===
          'trade-recap-frontend-test.s3-website-us-east-1.amazonaws.com' ||
        window.location.host === 'localhost:8080',
      isWebsocketConnected: false,
      isBidAccumulator: window.location.pathname.includes('bidaccumulator'),
      isTicketSystem: window.location.pathname.includes('ticketsystem'),
      isOfferingFeed: window.location.pathname.includes('offeringfeed'),
      isDeMinimis: window.location.pathname.includes('de-minimis'),
      showMFAPopup: false,
      isRiskManager: false,
      setAsAway: false,
      isBrockerDealer: null,
      isClient: window.location.pathname.includes('client'),
      searchText: '',
      isOnlyClientDashboard: window.location.pathname.includes('/client/dashboard'),
      isClientUser: false 
    }
  },
  methods: {
      startTour() {
        localStorage.removeItem('client_tour_completed_dashboard')
        localStorage.removeItem('client_tour_completed_filter')
        localStorage.removeItem('client_tour_completed_bids')
        localStorage.removeItem('client_tour_completed_portfolio')
        this.$router.push({ path: '/client/dashboard' })
        //setTimeout(() => {
           this.$tours['myTour'].start()
       // }, 1000);

      },
    logout: function () {
      this.deleteFCMToken()
      // setTimeout(() => {
      //   this.$root.$emit("logout");
      //   this.$cognitoAuth.logout();
      //   this.$router.push({ path: "/" });
      // },2000)
    },
    setAway () {
      let dataToSend = [
        {
          setting: 'AWAY',
          dataType: 'BOOLEAN',
          value: this.setAsAway ? 'true' : 'false',
          cognitoSub: authService.getUser().cognitoSub
        }
      ]
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .post(config.baseUrlBidSide + '/tradebook/setting', dataToSend, auth)
        .then(() => {
          this.$alert('Saved successfully ', '', 'success')
        })
        .catch(e => {
          console.log(e)
        })
    },
    getUserSetting () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/tradebook/setting-list?cognitoSub=' +
            authService.getUser().cognitoSub,
          auth
        )
        .then(result => {
          this.userSettings = result.data
          this.userSettings.forEach(element => {
            if (element.setting == 'AWAY') {
              this.setAsAway = element.value == 'true' ? true : false
            }
          })
        })
        .catch(e => {
          console.log(e)
        })
    },
    showPrintOptions () {
      this.$root.$emit('onprint')
    },
    testBid () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http.get(
        config.baseUrlBidSide +
          '/alert/add-to-queue?cognitoSub=' +
          authService.getUser().cognitoSub,
        auth
      )
    },
    testIms () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http.get(
        config.baseUrlBidSide +
          '/alert-firebase/add-to-queue?cognitoSub=' +
          authService.getUser().cognitoSub +
          '&fcmTokens=' +
          localStorage.getItem('fcmtoken') +
          '&msg=NEW ORDER RECIEVED',
        auth
      )
    },
    testNotification () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      const self = this
      if (!localStorage.getItem('fcmtoken')) {
        return false
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/alert-firebase/add-to-queue?cognitoSub=' +
            authService.getUser().cognitoSub +
            '&fcmTokens=' +
            localStorage.getItem('fcmtoken') +
            '&msg=TESTNOTIFICATION',
          auth
        )
        .then(response => {
          console.log('test notification result', response)
          Notification.requestPermission().then(function (result) {
            if (result === 'denied' || result === 'default') {
              return
            }
            if (response.data === 0) {
              self.$alert(
                'Please block the notification permission and allow it again to receive notifications from ECN.',
                'Notification Disconnected',
                'error'
              )
            }
          })
        })
    },
    search () {
      this.searchText = this.searchText.trim()
      this.$root.$emit('onsearch', this.searchText)
    },
    deleteFCMToken () {
      if (localStorage.getItem('fcmtoken')) {
        let cognitoSub = authService.getUser().cognitoSub
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        let tokenObj = {
          fcmToken: localStorage.getItem('fcmtoken'),
          cognitoSub: cognitoSub
        }
        this.$http
          .put(config.baseUrlBidSide + '/fcm/fcm-de-register', tokenObj, auth)
          .then(() => {
            this.$messaging.deleteToken()
            this.$root.$emit('logout')
            this.$cognitoAuth.logout()
            this.$router.push({ path: '/' })
          })
          .catch(() => {
            this.$root.$emit('logout')
            this.$cognitoAuth.logout()
            this.$router.push({ path: '/' })
          })
      } else {
        this.$root.$emit('logout')
        this.$cognitoAuth.logout()
        this.$router.push({ path: '/' })
      }
    }
  },
  created: function () {
    // this.$cognitoAuth.logout();
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.roleArray = role.map(item => {
          return item
            .split('-')[1]
            .replace('BrokerDealer', '')
            .replace('_', '')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
        })

        this.roleArray.includes('Admin')
          ? (this.isAdmin = true)
          : (this.isAdmin = false)
        this.roleArray.includes('Trader')
          ? (this.isTrader = true)
          : (this.isTrader = false)
        this.roleArray.includes('Editor')
          ? (this.isEditor = true)
          : (this.isEditor = false)
        this.roleArray.includes('SuperAdmin')
          ? (this.isSuperAdmin = true)
          : (this.isSuperAdmin = false)
        this.roleArray.includes('Risk Manager')
          ? (this.isRiskManager = true)
          : (this.isRiskManager = false)
        this.roleArray.includes('Client')
          ? (this.isClientUser = true)
          : (this.isClientUser = false)  
      }
      //console.log("isa",this.isAdmin);
    })
    this.modules = authService.getModule()
    this.user = authService.getUser() ? authService.getUser() : {}
    this.todate = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    var ourDate = new Date()
    var pastDate = ourDate.getDate() - 7
    ourDate.setDate(pastDate)
    this.fromdate = ourDate.toJSON().slice(0, 10).replace(/-/g, '-')
    if (this.$route.matched.length > 0 && this.$route.matched[0].name) {
      this.currentPathParent = this.$route.matched[0].name
    }
    setTimeout(() => {
      this.testNotification()
    }, 5000)

     this.$watch(
      () => this.$route,
      () => {
        this.isOnlyClientDashboard =  window.location.pathname.includes('/client/dashboard')
     
      });
  },
  mounted () {

    this.$root.$on('tradedate', data => {
      this.fromdate = data.fromDate
      this.todate = data.toDate
    })
    this.$root.$on('websocketconnected', data => {
      this.isWebsocketConnected = data.show
    })
    this.isBrockerDealer = window.location.pathname.includes('brockerdealer')

    if ((!this.isBrockerDealer && this.isTrader) || this.isEditor) {
      this.getUserSetting()
    }
  },

}
</script>
